import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import { alpha, styled } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

const SnackBar = () => {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const loading = false;

  return (
    <Box
      sx={{ position: 'absolute', width: '100%', height: '100%', bottom: 0 }}
    >
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        sx={{ bgcolor: 'background.paper' }}
      >
        <Paper
          sx={{
            bgcolor: (theme) =>
              true
                ? alpha(theme.palette.success.main, 0.2)
                : alpha(theme.palette.error.main, 0.2),
          }}
        >
          <Box sx={{ width: 350, minHeight: 150, p: 2 }}>
            <Stack
              justifyContent="space-between"
              alignItems="baseline"
              direction="row"
              sx={{ flexGrow: 1, mb: 1 }}
            >
              <Stack spacing={1} direction="row" alignItems="center">
                {true ? (
                  <CheckCircleIcon color="success" fontSize="large" />
                ) : (
                  <ErrorIcon color="error" fontSize="large" />
                )}
                <Typography variant="h6" color="text.primary">
                  Lorem, ipsum dolor
                </Typography>
              </Stack>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Stack>
            <Typography color="text.secondary">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Accusamus, deserunt.
            </Typography>
          </Box>
        </Paper>
      </Snackbar>
    </Box>
  );
};

export default SnackBar;
